import { AppError } from './app-errors'

export class OperationResult<T = void> {
  public readonly result: T | undefined
  public readonly error: AppError | undefined

  constructor(result?: T, error?: AppError) {
    this.error = error
    this.result = result
  }

  public isError(): this is { error: AppError; result: undefined } {
    return this.error !== undefined
  }

  public isSuccess(): this is { result: T; error: undefined } {
    return this.error === undefined
  }
}

export function error<T>(error: AppError): OperationResult<T>
export function error<T>(errorMessage: string): OperationResult<T>
export function error<T>(error: AppError | string): OperationResult<T> {
  const err = typeof error === 'string' ? new AppError(error) : error
  return new OperationResult<T>(undefined, err)
}

export function success(): OperationResult
export function success<T>(result: T | null): OperationResult<T>
export function success<T>(result?: T): OperationResult<T | void> {
  return new OperationResult(result)
}
